var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('MegasredaContentLayoutBase', {
    scopedSlots: _vm._u([{
      key: "main",
      fn: function () {
        return [_c('PagesNavigatorProductHeader'), _vm._v(" "), _c('NuxtChild')];
      },
      proxy: true
    }, {
      key: "column",
      fn: function () {
        return [_c('MegasredaRecomendedBaseBlock')];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }